import { QueryEntity, EntityActions } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { map, switchMap, filter, first } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { EventInput } from '@fullcalendar/core';
import { VacationEventsState, VacationEventsStore } from './vacation-events.store';

@Injectable()
export class VacationEventsQuery extends QueryEntity<VacationEventsState> {
    filtered$ = this.select(state => state.ui.filtered)
        .pipe(
            switchMap(ids => this.selectMany(ids).pipe(first()))
        );

    dareRange$ = this.select(state => state.ui.dateRange);

    selectSet$ = this.selectEntityAction()
        .pipe(
            filter(action => {
                return action.type === EntityActions.Set
            }),
            switchMap(action => this.selectMany(action.ids).pipe(first()))
        );

    constructor(protected store: VacationEventsStore) {
        super(store);
    }
}